angular.module('psModule').factory('assetService',['$q', '$resource', function($q, $resource) {

    var assetResource = $resource('/ps/api/assets/:by', {}, {
        'get': {method:'GET', params:{}, isArray:true},
        'getInsuranceAssets': {method: 'GET', params: {by: 'insurance'}, isArray: true}
    });
	return assetResource;
}]);
